/** Названия полей для react-hook-forms */
export const FieldName = /*#__PURE__*/ {
  /** Контакты */
  Contacts: 'contacts',
  /** Точки "Откуда"/"Куда" */
  Route: 'route',
  /** Данные для оплаты */
  PaymentInfo: 'payment_info',
  /** Поле для данных Ndd */
  Ndd: 'ndd',
} as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FieldName = typeof FieldName[keyof typeof FieldName]

/** Точка отправления в роуте */
export const routeSourceName = 'source'

/** Префикс для точек прибытия в роуте */
export const routeDestinationPrefixName = 'destination_'

export const routeReturnName = 'return'
